import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Box, Grid, makeStyles, MenuItem, TextField, Button } from "@material-ui/core";
import { Autocomplete } from '@material-ui/lab'
import { useTranslation } from "react-i18next";
import _ from "lodash";
import FormSectionHeader from "../FormSectionHeader";
import SelectWithInput from "../SelectWithInput";
import { getUserPreference } from "../../../../utilities/common";
import UniDialog from '../../../Common/UniDialog';
import { useAlert } from '../../../../utilities/hooks';
import { batchInprogressIncident } from '../../../../actions/incidentManagementActions'

const useStyles = makeStyles((theme) => ({
  section: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  bottomSubmit: {
    display: 'flex',
    justifyContent: 'center',
    padding: theme.spacing(4),
  }
}))

function BatchInProgressForm(props) {
  const classes = useStyles();
  const { t } = useTranslation('incidentManagement');
  const userPref = getUserPreference();
  const { data, userList, statusList, inidentIds, onClose, branchList, onFormChange, open, ...rest } = props;
  const { causedByList, rootCauseList, resultList, correctiveActionList } = statusList;
  const [isUpdated, setIsUpdated] = useState(false);
  const alertDialog = useAlert();
  const dispatch = useDispatch();
  const [note, setNote] = useState('');
  
  const getValue = (event) => {
    setNote({ vale: event.target.value })
  }

  const handleBatchInProgress = async () => {
    let params = {
      incident_ids: inidentIds,
      handler: userPref.userId,
      caused_by: data.caused_by,
      caused_by_detail: data.caused_by_detail ?? null,
      root_cause: data.root_cause,
      root_cause_detail: data.root_cause_detail ?? null,
      result_type: data.result_type ?? null,
      result_detail: data.result_detail ?? null,
      corrective_action: data.corrective_action,
      corrective_action_detail: data.corrective_action_detail ?? null,
      notes: note ?? null,
    }
    try {
      let responseData = await dispatch(batchInprogressIncident(params));
      let successList = [];
      let failList = [];
      _.forEach(responseData, (value) => {
        if (value.success) {
          successList.push(value.id)
        } else {
          failList.push(value.id)
        }
      })

      alertDialog.addAlertDialog(
        t('dialog:incident_batch_close'),
        [
          t('dialog:incident_batch_close_message'),
          `Failed: ${failList.length > 0 ? failList.join(", ") : "None"}`,
          `Success: ${successList.length > 0 ? successList.join(", ") : "None"}`
        ], null,
        t('common:ok'),
        () => {
          setIsUpdated(true);
          setNote('');
          alertDialog.hideAlert();
        }
      );
      alertDialog.showAlert();
    } catch (error) {
      alertDialog.addAlertDialog(
        t('dialog:incident_batch_close'),
        error.message
      );
      alertDialog.showAlert();
    }
  }
  return (
    <UniDialog
      title={t('incident_form')}
      open={open}
      onClose={() => {
        onClose(isUpdated)
      }}
      {...rest}
    >
      <Box {...rest}>
        <FormSectionHeader
          title={t('in_progress')}
        />
        <form>
          <Grid container spacing={4} className={classes.section}>
            <Grid item xs={6}>
              <Autocomplete
                id="autocomplete-user-list"
                name="handler"
                options={userList}
                getOptionLabel={(option) => option.username}
                renderInput={(params) => <TextField {...params} label={t('handled_by')} variant='outlined' />}
                fullWidth
                value={_.find(userList, { 'id': parseInt(userPref.userId) || null })}
                onChange={(event, newValue) => {
                  event.target.name = "handler"
                  event.target.value = newValue?.id //we want the id instead of the default index
                  onFormChange(event) //set for actual data change
                }}
              />
            </Grid>
            <SelectWithInput
              selectGridProps={{ item: true, xs: 6 }}
              inputGridProps={{ item: true, xs: 12 }}
              selectArray={causedByList}
              selectLabel={t('caused_by')}
              inputLabel={t('caused_by_detail')}
              selectName='caused_by'
              inputName='caused_by_detail'
              selectValue={data.caused_by}
              inputValue={data.caused_by_detail}
              handleChange={onFormChange}
              selectRequired
            />
            <SelectWithInput
              selectGridProps={{ item: true, xs: 12 }}
              inputGridProps={{ item: true, xs: 12 }}
              selectArray={rootCauseList}
              selectLabel={t('root_cause')}
              inputLabel={t('root_cause_detail')}
              selectName='root_cause'
              inputName='root_cause_detail'
              selectValue={data.root_cause}
              inputValue={data.root_cause_detail}
              handleChange={onFormChange}
              selectRequired
              inputRequired
            />
            <SelectWithInput
              selectGridProps={{ item: true, xs: 12 }}
              inputGridProps={{ item: true, xs: 12 }}
              selectArray={resultList}
              selectLabel={t('result_type')}
              inputLabel={t('result_type_detail')}
              selectName='result_type'
              inputName='result_detail'
              selectValue={data.result_type}
              inputValue={data.result_detail}
              handleChange={onFormChange}
              inputRequired
            />
            <SelectWithInput
              selectGridProps={{ item: true, xs: 12 }}
              inputGridProps={{ item: true, xs: 12 }}
              selectArray={correctiveActionList}
              selectLabel={t('remedial_corrective_action')}
              inputLabel={t('remedial_corrective_action_detail')}
              selectName='corrective_action'
              inputName='corrective_action_detail'
              selectValue={data.corrective_action}
              inputValue={data.corrective_action_detail}
              handleChange={onFormChange}
              inputRequired
            />
            <Grid item xs={12}>
              <TextField
                id="input-notes"
                label={t('notes')}
                name="notes"
                variant='outlined'
                defaultValue={note}
                multiline
                onChange={getValue}
                rows={4}
                fullWidth
              />
            </Grid>
          </Grid>
          <div className={classes.bottomSubmit}>
            <Button
              color='primary'
              variant='contained'
              onClick={handleBatchInProgress}
            >
              {t('batch_inprogress')}
            </Button>
          </div>

        </form>
      </Box>
    </UniDialog>
  )
}

export default BatchInProgressForm;